import yaml from 'js-yaml';

export interface Size { width: number; height: number; }

async function loadText(path: string): Promise<string> {
  try {
    const response = await fetch(process.env.BASE_URL + path);
    return await response.text();
  } catch (err) {
    window.console.error('textファイルの読み込みに失敗しました', path);
    throw err;
  }
}

export async function loadYaml<T>(path: string): Promise<T> {
  try {
    const text = await loadText(path);
    const result = yaml.safeLoad(text) as any;
    return result as T;
  } catch (err) {
    window.console.error('yamlファイルの読み込みに失敗しました', path);
    throw err;
  }
}

export function dynamicAddScript(url: string): void {
  const script = document.createElement('script');
  script.src = url;
  const firstScript: HTMLScriptElement = document.getElementsByTagName(
    'script',
  )[0] as HTMLScriptElement;
  firstScript.parentNode!.insertBefore(script, firstScript);
}

export function getSizeRatio(frameWidth: number): number {
  const ww = document.getElementById('app')!.getBoundingClientRect().width;
  const contentsWidth = Math.min(frameWidth, ww);
  return contentsWidth / frameWidth;
}
